import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.scss';
import Home from './pages/Home';
import MobileOTP from './pages/MobileOTP';
import Dashboard from './pages/Dashboard';
import Error404 from './pages/Error404';
import DialerCampaign from './pages/DialerCampaign';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export default function App() {
    return <>
        <BrowserRouter><Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mobile-otp" element={<MobileOTP />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dialer-campaign" element={<DialerCampaign />} />
            <Route path="*" element={<Error404 />} />
        </Routes></BrowserRouter>
        <ToastContainer position="bottom-center" />
    </>;
}
